const REFRESH_INTERVAL = 1000;
const TYPING_TIMEOUT = 5000;

export default class TypingTracker {
  constructor(callback, isOneToOne = false) {
    this.callback = callback;
    this.isOneToOne = isOneToOne;
    this.currentlyTyping = {};
    this.timer = setInterval(this.#refresh.bind(this), REFRESH_INTERVAL);
  }

  close() {
    clearInterval(this.timer);
  }

  add(name) {
    this.currentlyTyping[name] = Date.now();
    this.#refresh();
  }

  remove(name) {
    delete this.currentlyTyping[name];
    this.#refresh();
  }

  #refresh() {
    this.#purgeInactive();
    const names = Object.keys(this.currentlyTyping).sort((a, b) => a.localeCompare(b));

    if (names.length > 0) {
      this.callback(this.isOneToOne ? 'Typing...' : this.#formatNames(names));
    } else {
      this.callback(null);
    }
  }

  #formatNames(names) {
    if (names.length === 1) {
      return `${names[0]} is typing...`;
    }

    if (names.length === 2) {
      return `${names[0]} and ${names[1]} are typing...`;
    }

    if (names.length === 3) {
      return `${names[0]}, ${names[1]} and ${names[2]} are typing...`;
    }

    const remaining = names.length - 2;

    return `${names[0]}, ${names[1]} and +${remaining} users are typing...`;
  }

  #purgeInactive() {
    const cutoff = Date.now() - TYPING_TIMEOUT;
    this.currentlyTyping = Object.fromEntries(
      Object.entries(this.currentlyTyping).filter(([_name, timestamp]) => timestamp > cutoff)
    );
  }
}
